module.exports = __webpack_public_path__ + "static/media/linkedin1.8f4afe0f.png";